<!-- 3D Iframe -->
<template>
  <div 
    v-if="isShow"
    class="iframe3d"
    :class="`iframe3d iframe3d-${status}`"
  > 
    <!-- 解析中 -->
    <div v-if="status === 0" class="iframe3d__analyzeing">
      <img :src="require('@@/assets/img/icons/icon_3d_1.png')" />
      <span>3D仿真图解析中</span>
    </div>
    <!-- 解析成功 -->
    <div v-if="status === 1" class="iframe3d__success">
      <!-- 已折叠 -->
      <div 
        v-if="!isShowContent" 
        class="iframe3d__success__collapsed"
        @click="handleChangeShowContent"
      >
        <p>3D仿真图 和 Gerber</p>
        <div>
          <span>已折叠</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <!-- 展开 -->
      <div v-else class="iframe3d__success__tabs">
        <div 
          class="iframe3d__success__tabs__item tab-3d" 
          :class="{ 'is-active': activeTab === '3d' }"
          @click="handleChangeTab('3d')"
        >
          <template v-if="activeTab === '3d'">
            <span class="iframe3d__success__tabs__item__name">3D仿真图</span>
            <div class="iframe3d__success__tabs__item__btns" @click.stop>
              <p :class="{ 'active': activeLayer === 'top' }" @click="handleChangeLayer('top')">
                顶层
              </p>
              <p :class="{ 'active': activeLayer === 'bottom' }" @click="handleChangeLayer('bottom')">
                底层
              </p>
            </div>
          </template>
          <span v-else class="iframe3d__success__tabs__item__name">3D仿真图</span>
        </div>
        <i :class="`iframe3d__success__tabs__divider divider-${activeTab}`" />
        <div 
          class="iframe3d__success__tabs__item tab-gerber" 
          :class="{ 'is-active': activeTab === 'gerber' }"
          @click="handleChangeTab('gerber')"
        >
          <span class="iframe3d__success__tabs__item__name">Gerber在线查看</span>
        </div>
        <div class="iframe3d__success__tabs__btn" @click="handleChangeShowContent">
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <!-- iframe -->
      <div v-show="isShowContent" class="iframe3d__success__content">
        <iframe 
          v-if="iframeSrc"
          id="iframe3d" 
          :src="iframeSrc" 
          width="100%" 
          height="260" 
          allowfullscreen="true"
        />
      </div>
    </div>
    <!-- 解析失败 -->
    <div v-if="status === 2" class="iframe3d__fail">
      <div>
        <img :src="require('@@/assets/img/icons/icon_3d_2.png')" />
        <span>3D仿真图解析失败</span>
      </div>
      <p class="iframe3d__fail__btn" @click="handleClose">
        关闭
      </p>
    </div>
  </div>
</template>

<script>
import { 
  HQPCB_HOST,
  file3DAnalyzeResult
} from '@@/api/pcb'

// 阻焊颜色
const COLOR_MAP = {
  '绿色': 'green',
  '蓝色': 'blue',
  '黑色': 'black',
  '红色': 'red',
  '黄色': 'yellow',
  '白色': 'white',
  '哑光黑油': 'black'
}
// 表面处理
const PAD_MAP = {
  '有铅喷锡': 'tin',
  '无铅喷锡': 'tin',
  '沉金': 'gold',
  'OSP': 'OSP',
}

// 解析
const defaultAnalyze = {
  analyzeing: false, //解析中
  analyzeTimer: null, // 解析接口定时器
}

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    analyzeId: {
      type: String,
      default: ''
    },
    analyzeKey: {
      type: [String, Number],
      default: 0
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isShow: false,
      isShowContent: true,
      status: 0, // 状态：0-解析中, 1-解析成功, 2-解析失败   0-未开始, 1-解析中, 2-解析失败, 3-解析成功
      analyze: { ...defaultAnalyze },
      activeTab: '3d', // 3d-3D仿真图, gerber-Gerber在线查看
      activeLayer: 'top', // // top-顶层, bottom-底层
      iframeUrlParams: {}
    }
  },
  computed: {
    iframeParams() {
      const { type, height, color, pad } = this.params
      return {
        type: type || 'FR-4',
        height: height || '',
        pad: PAD_MAP[pad] || '',
        color: COLOR_MAP[color] || '',
      }
    },
    iframeSrc() {
      if (this.status !== 1) return ''

      const { analyzeId, analyzeKey, iframeParams, iframeUrlParams } = this

      // url只带初始化时的参数
      if (!iframeUrlParams[analyzeId]) {
        iframeUrlParams[analyzeId] = Object.entries(iframeParams).map(([key, value]) => `&${key}=${value}`).join('')
      }

      // return `http://localhost:5173/iframeviewerV2?id=${analyzeId}&key=${analyzeKey}${iframeUrlParams[analyzeId] || ''}`
      return `${HQPCB_HOST}/gerberviewer/iframeviewerV2?id=${analyzeId}&key=${analyzeKey}${iframeUrlParams[analyzeId] || ''}`
    }
  },
  watch: {
    analyzeId(newVal) {
      this.init(!!newVal)
    },
    analyzeKey(newVal) {
      this.init(newVal || newVal === 0)
    },
    params(newVal) {
      this.handleParamsChange()
    }
  },
  methods: {
    init(isShow) {
      if (isShow) {
        this.isShow = true
        this.startAnalyze()
      } else {
        this.isShow = false
      }
    },
    // 关闭
    handleClose() {
      this.isShow = false
    },
    // 3D/Gerber切换
    handleChangeTab(tab) {
      if (this.activeTab === tab) return
      this.activeTab = tab
      this.activeLayer = 'top'
      this.handleLayerChange(tab)
    },
    // 顶层/底层切换
    handleChangeLayer(layer) {
      if (this.activeLayer === layer) return
      this.activeLayer = layer
      this.handleLayerChange(layer)
    },
    // 展开/收起
    handleChangeShowContent() {
      this.isShowContent = !this.isShowContent
    },
    handleParamsChange() {
      this.$nextTick(() => { 
        const iframe3d = document.getElementById('iframe3d')
        if (iframe3d) {
          iframe3d.contentWindow.postMessage({ 
            name: 'switchPcbColor', 
            ...this.iframeParams
          }, HQPCB_HOST)
        }
      })
    },
    handleLayerChange(type) {
      const params = {
        '3d': { type: 'viewer', label: '3d' },
        'gerber': { type: 'viewer', label: 'gerber' },
        'top': { type: '3dFace', label: 'top' },
        'bottom': { type: '3dFace', label: 'bottom' },
      }[type]

      this.$nextTick(() => { 
        const iframe3d = document.getElementById('iframe3d')
        if (iframe3d) {
          iframe3d.contentWindow.postMessage({ 
            name: 'switchPcbLabel', 
            ...params
          }, HQPCB_HOST)
        }
      })
    },
    initStatus() {
      this.status = 0
      this.activeTab = '3d'
      this.activeLayer = 'top'
    },
    // 文件解析
    startAnalyze() {
      this.analyze.analyzeTimer && clearInterval(this.analyze.analyzeTimer)
      this.initStatus()

      this.analyze.analyzeing = true
      const params = { analyze_id: this.analyzeId, key: this.analyzeKey }
      this.analyze.analyzeTimer = setInterval(() => {
        file3DAnalyzeResult(params)
          .then(res => {
            if (!res) return
            const { code } = res
            // code: 200-解析成功 105-解析中  其余的都算失败
            if (code == 200) {
              // 解析成功
              this.endAnalyze(1)
            } else if (code != 105) {
              // 解析失败
              this.endAnalyze(2)
            }
          })
          .catch(err => {})
      }, 1500)
    },
    // 解析完成：1-解析成功 2-解析失败
    endAnalyze(status) {
      clearInterval(this.analyze.analyzeTimer)
      this.analyze.analyzeing = false
      const timer = setTimeout(() => {
        this.status = status
        this.isShowContent = status === 1
        clearTimeout(timer)
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>

$borderRadius: $--border-radius-base2;
$borderColor: #E6E6E6;
$borderColorHover: #AAAAAA;
$tabHeight: 34px;

.iframe3d {
  box-sizing: border-box;
  margin-bottom: 6px;
  border-radius: $--border-radius-base2;
  border: 1px solid $borderColor;
  background-color: #fff;
  &:hover {
    border-color: $borderColorHover;
  }
  &.iframe3d-0 {
    border-color: #fff;
  }
  &.iframe3d-1 {
    border-color: #E6E6E6;
  }
  &.iframe3d-2 {
    border-style: dashed;
    border-color: #FF4D4F;
  }
}

.iframe3d__analyzeing {
  display: flex;
  align-items: center;
  padding-left: 11px;
  height: $tabHeight;
  color: #3F96F0;
  background-color: #F4F9FF;
  >img {
    display: block;
    width: 16px;
    animation: spin 1s linear infinite;
  }
  >span {
    margin-left: 6px;
  }
  // 转圈动画
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
}

.iframe3d__fail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px 0 11px;
  height: $tabHeight;
  color: #FF4D4F;
  background-color: #fff;
  >div {
    display: flex;
    align-items: center;
    >img {
      display: block;
      width: 16px;
    }
    >span {
      margin-left: 6px;
    }
  }
  .iframe3d__fail__btn {
    width: 40px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 12px;
    color: #555555;
    background-color: #fff;
    border-radius: $--border-radius-base2;
    cursor: pointer;
    &:hover {
      color: #111111;
      background-color: #F5F5F5;
    }
  }
}

.iframe3d__success {
  $tabBorderColor: #E6E6E6;
  $tabBackgroundColor: #FBFBFB;
  .iframe3d__success__tabs {
    display: flex;
    height: $tabHeight;
    .iframe3d__success__tabs__item {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $tabBackgroundColor;
      border-bottom: 1px solid $tabBorderColor;
      cursor: pointer;
      &.is-active {
        border-bottom-color: transparent;
        background-color: #fff;
        .iframe3d__success__tabs__item__name {
          font-weight: 700;
        }
        &.tab-3d {
          justify-content: flex-start;
          padding-left: 16px;
        }
      }
      &.tab-3d {
        flex: 1;
      }
      &.tab-gerber {
        width: 162px;
      }
      .iframe3d__success__tabs__item__name {
        font-size: 12px;
        color: #111111;
      }
      .iframe3d__success__tabs__item__btns {
        margin-left: 22px;
        display: flex;
        >p {
          width: 36px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #555555;
          border-radius: 2px;
          &:hover {
            background-color: #F5F5F5;
          }
          &.active {
            position: relative;
            color: #15A675;
            &::after {
              content: '';
              position: absolute;
              left: 13px;
              bottom: 0;
              display: block;
              width: 10px;
              height: 2px;
              background-color: #15A675;
            }
          }
          & + p {
            margin-left: 3px;
          }
        }
      }
    }
    .iframe3d__success__tabs__divider {
      margin-top: -1px;
      display: block;
      width: 27px;
      height: 35px;
      &.divider-3d {
        background: url('~@@/assets/img/icons/icon_3d_tab_1.png') no-repeat;
        background-position-x: 4px;
      }
      &.divider-gerber {
        background: url('~@@/assets/img/icons/icon_3d_tab_2.png') no-repeat;
        background-position-x: -5px;
      }
    }
    .iframe3d__success__tabs__btn {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: $tabHeight;
      font-size: 12px;
      border-left: 1px solid $tabBorderColor;
      border-bottom: 1px solid $tabBorderColor;
      background-color: #fff;
      cursor: pointer;
    }
  }

  .iframe3d__success__collapsed {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 9px 0 11px;
    height: $tabHeight;
    font-size: 12px;
    cursor: pointer;
    >p {
      color: #555555;
    }
    >div {
      >span {
        margin-right: 5px;
        color: #BBBBBB;
      }
    }
  }

  .iframe3d__success__content {
    padding: 5px;
    height: 260px;
  }
}


</style>